var dropdownItemList = 'itemList_dropdownItemList__jzm7hy0';

export { dropdownItemList };
//# sourceMappingURL=itemList.vanilla.mjs.map
